import { createAction } from 'redux-actions';
import { createRoutine } from '../common/utils/routines.js';

export const getApiKeys = createRoutine('apiKeys/GET_API_KEYS');
export const deleteApiKey = createRoutine('apiKeys/DELETE_API_KEY');
export const createApiKey = createRoutine('apiKeys/CREATE_API_KEY');

export const deleteSelectedApiKeys = createAction('apiKeys/DELETE_SELECTED_API_KEYS');
export const apiKeyCreationModalClosed = createAction('apiKeys/CREATION_MODAL_CLOSED');
